import React, { isValidElement } from "react";
import shortid from "shortid";
import PropTypes from "prop-types";
import b64toBlob from "b64-to-blob";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import swal from "sweetalert";
import Select from "react-select";
import {
  getBase64,
  regexValidate,
  validateNRIC,
  validation,
} from "../../utils/common";
import "../../assets/css/form-style.css";

class Tab3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renewalApplication: props.user.loggedInUser
        ? props.user.loggedInUser.Partner_Authority__c === null
        : false,
      // dob: null,
      // setData: false,
      bencount: props.user.loggedInUser
        ? props.user.loggedInUser.Partner_Authority__c === null
          ? 0
          : 1
        : 1,
      // bencountList: [],
      schoolList: [],
      // selectedCS: null,
      // selectedAT: null,
      // msList: [],
      // nationList: [],
      // Ben: [{ data: {}, attachment: {} }],
      isValidEmailFormat: [],
      isValidBenNric: [],
      curLevelBySchool: [[]],
      applyingToList: [[]],
      subTypes: [""],
      apllTypes: [
        "Family Service Centre",
        "Volunteer Welfare Organisation",
        "Homes",
        "SPED",
        "Youth Centres",
        "Transition shelters",
        "Others",
      ],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    // this.handleDOBChange = this.handleDOBChange.bind(this);
    this.addCount = this.addCount.bind(this);
    this.updateBen = this.updateBen.bind(this);
    // this.csChanged = this.csChanged.bind(this);
    // this.atChanged = this.atChanged.bind(this);
    this.uploadBen = this.uploadBen.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.refreshSchoolLevel = this.refreshSchoolLevel.bind(this);
    this.minCount = this.minCount.bind(this);

    this.currentSchoolSelect = null;
    this.setCurrentSchoolRef = (element) => {
      this.currentSchoolSelect = element;
    };
  }

  componentWillMount() {
    const { Ben } = this.props.data;
    const isValidBenNric = Ben.map((bene) =>
      validateNRIC(bene.data.ID_Number__c).toString()
    );

    this.props.data.isValidBenNric = isValidBenNric;
    this.setState({
      bencount: Ben.length,
      isValidBenNric,
    });

    this.refreshSchoolLevel(this.props);
  }

  componentDidMount() {
    const schoolList = [];
    if (this.props.salesforce.schoolList.fields.records === undefined) return;
    if (this.props.salesforce.schoolList.fields.records.length > 0) return;
    this.props.salesforce.schoolList.fields.records.map((field) => {
      schoolList.push({
        type: "school_list",
        value: field.Id,
        label: field.Name,
      });
    });
    // this.state.schoolList = schoolList;

    // Check beneficiaries' NRIC numbers
    this.state.Ben.map((bene) => {
      bene.data;
    });

    this.setState({
      schoolList,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.renewalApplication) {
      if (this.props.data.Ben.length > 0) {
        this.setState({
          bencount: this.props.data.Ben.length,
        });
      }

      const BenData = this.props.data.Ben[0].data;
      if (BenData.hasOwnProperty("Current_School__c")) {
        if (
          this.props.data.schoolList !== undefined &&
          this.props.data.currLevelList !== undefined
        ) {
          const { length } = this.props.data.Ben;
          const index = 0;

          this.currentLevalUpdate(
            this.props.data.Ben[index].data.Current_School__c,
            index,
            length
          );
        }
      }
      if (
        this.props.data.applyingToList.length > 0 &&
        this.props.data.Ben.length > 0
      ) {
        console.log("enter in 3");
        const applyingToList = [[]];
        for (let i = 0; i < this.props.data.Ben.length; i++) {
          applyingToList[i] = this.props.data.applyingToList.filter(
            (applItem) => {
              if (applItem.value === this.props.user.loggedInUser.Account.Id) {
                return applItem;
              }
              if (applItem.value === this.props.data.Ben[i].Applying_to__c) {
                return applItem;
              }
              if (this.state.apllTypes.includes(applItem.type)) {
                return applItem;
              }
            }
          );
        }
        this.setState({
          applyingToList,
        });
      }
    }

    const { Ben } = nextProps.data;
    const isValidBenNric = Ben.map((bene) =>
      validateNRIC(bene.data.ID_Number__c).toString()
    );

    nextProps.data.isValidBenNric = isValidBenNric;
    this.setState({
      bencount: Ben.length,
      isValidBenNric,
    });

    this.refreshSchoolLevel(nextProps);
  }

  refreshSchoolLevel(theProps) {
    const { subTypes, curLevelBySchool, applyingToList } = this.state;

    for (let a = 0; a < theProps.data.Ben.length; a++) {
      const benIdx = Number(`Ben${a}[Current_School__c]`.match(/\d+/)[0]);

      applyingToList[benIdx] = theProps.data.applyingToList.filter(
        (applItem) => {
          if (applItem.value === this.props.user.loggedInUser.Account.Id) {
            return applItem;
          }

          if (applItem.value === theProps.data.Ben[a].data.Current_School__c) {
            return applItem;
          }
          if (this.state.apllTypes.includes(applItem.type)) {
            return applItem;
          }

          return false;
        }
      );

      theProps.data.schoolList.map((item) => {
        if (item.value === theProps.data.Ben[a].data.Current_School__c) {
          const subtype = item.type;
          subTypes[benIdx] = subtype;
          if (subtype === "Primary School") {
            curLevelBySchool[benIdx] = theProps.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("Primary")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
              }
            );
          } else if (subtype === "Secondary School") {
            curLevelBySchool[benIdx] = theProps.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("Secondary")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
              }
            );
          } else if (subtype === "ITE") {
            curLevelBySchool[benIdx] = theProps.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("NITEC")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
              }
            );
          } else if (subtype === "Polytechnic") {
            curLevelBySchool[benIdx] = theProps.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("Polytechnic")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
              }
            );
          } else if (subtype === "Junior College") {
            curLevelBySchool[benIdx] = theProps.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("JC")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
              }
            );
          } else if (subtype === "Pri/Sec School") {
            curLevelBySchool[benIdx] = theProps.data.currLevelList.filter(
              (clItem) => {
                if (
                  clItem.value.includes("Primary") ||
                  clItem.value.includes("Secondary")
                ) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
              }
            );
          } else if (subtype === "Sec/JC School") {
            curLevelBySchool[benIdx] = theProps.data.currLevelList.filter(
              (clItem) => {
                if (
                  clItem.value.includes("Secondary") ||
                  clItem.value.includes("JC")
                ) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
              }
            );
          } else if (subtype === "SPED") {
            curLevelBySchool[benIdx] = theProps.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("SPED")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
              }
            );
          }
        }
      });
    }

    this.setState({
      curLevelBySchool,
    });
  }

  /* csChanged(selectedCS, evt) {
        this.setState({ selectedCS, selectedCS });
    } */

  /* atChanged(selectedAT) {
        this.setState({ selectedAT });
    } */

  inputChangeHandler(event) {
    // this.setState({ [event.target.name]: event.target.value });
    this.props.changeState([event.target.name], event.target.value);
    this.setState({ [event.target.name]: event.target.value });
  }

  handleInputChange(event) {
    this.props.changeState([event.target.name], event.target.value);
  }

  /* handleDOBChange(date) {
        const newDate = date.format('YYYY/MM/DD').toString();
        // this.props.changeState('Date_of_Birth__c', date.format("YYYY/MM/DD").toString());
        this.setState({
            dob: newDate,
        });
    } */

  addCount() {
    const benValidation = validation(3, this.props.data);
    if (!benValidation.isValid) {
      if (benValidation.invalidFields.length > 0) {
        swal("please fill all required fields!");
      } else if (benValidation.invalidFiles.length > 0) {
        swal("please upload all required document!");
      }
    } else {
      const {
        isValidEmailFormat,
        isValidBenNric,
        subTypes,
        curLevelBySchool,
        applyingToList,
      } = this.state;
      isValidEmailFormat.push("");
      isValidBenNric.push("");
      subTypes.push("");
      curLevelBySchool.push([]);
      applyingToList.push([]);
      this.setState({
        bencount: this.state.bencount + 1,
        isValidEmailFormat,
        isValidBenNric,
        subTypes,
        curLevelBySchool,
        applyingToList,
      });
      this.props.data.Ben.push({
        data: {
          Date_of_Birth__c: "",
          ID_Type__c: "NRIC",
          Applying_to__c: this.props.user.loggedInUser.Account.Id,
        },
        attachment: {},
      });
      this.props.data.isValidBenEmail = this.state.isValidEmailFormat;
      this.props.data.isValidBenNric = this.state.isValidBenNric;
      this.forceUpdate();
    }
  }

  minCount(event) {
    const { Ben, Hou } = this.props.data;
    const { subTypes, curLevelBySchool, applyingToList } = this.state;
    let { bencount } = this.state;
    const benIdx = Number(event.target.id.match(/\d+/)[0]);
    bencount -= 1;
    const deletedBeneficiary = Ben[benIdx];
    Ben.splice(benIdx, 1);
    curLevelBySchool.splice(benIdx, 1);
    // console.log('cur', curLevelBySchool)
    subTypes.splice(benIdx, 1);
    applyingToList.splice(benIdx, 1);

    // Update state in parent component (<Registration>)
    this.props.changeState("Ben", Ben);

    // Move the deleted beneficiary to household member list
    Hou.push(deletedBeneficiary);
    this.props.changeState("Hou", Hou);

    this.setState({
      bencount,
      subTypes,
      curLevelBySchool,
    });
  }

  updateBen(event) {
    const BenList = this.props.data.Ben;
    const benIdx = Number(event.target.id.match(/\d+/)[0]);
    const { subTypes } = this.state;
    const { curLevelBySchool } = this.state;
    const { applyingToList } = this.state;
    let { value } = event.target;

    if (event.target.name.indexOf("Email") !== -1) {
      const isValidEmail = value !== "" ? regexValidate("email", value) : true;
      if (!isValidEmail) {
        document.getElementById(`ben_email_error${benIdx}`).innerHTML =
          "invalid email format";
      } else {
        document.getElementById(`ben_email_error${benIdx}`).innerHTML = "";
      }
      this.state.isValidEmailFormat[benIdx] = isValidEmail.toString();
      this.props.data.isValidBenEmail = this.state.isValidEmailFormat;
    }

    if (event.target.name === "ID_Number__c") {
      value = value.toUpperCase();
      if (BenList[benIdx].data.ID_Type__c !== "Others") {
        const isValidNric = validateNRIC(value);
        if (!isValidNric) {
          document.getElementById(`ben_nric_error${benIdx}`).innerHTML =
            "invalid format NRIC/FIN";
        } else {
          document.getElementById(`ben_nric_error${benIdx}`).innerHTML = "";
        }
        this.state.isValidBenNric[benIdx] = isValidNric.toString();
      }
      this.props.data.isValidBenNric = this.state.isValidBenNric;
    }

    if (event.target.name.indexOf("Current_School") !== -1) {
      applyingToList[benIdx] = this.props.data.applyingToList.filter(
        (applItem) => {
          if (applItem.value === event.target.value) {
            return applItem;
          }
          if (this.state.apllTypes.includes(applItem.type)) {
            return applItem;
          }

          return false;
        }
      );
      this.props.data.schoolList.map((item) => {
        if (item.value === event.target.value) {
          const subtype = item.type;
          subTypes[benIdx] = subtype;
          if (subtype === "Primary School") {
            curLevelBySchool[benIdx] = this.props.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("Primary")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
              }
            );
          }
          if (subtype === "Secondary School") {
            curLevelBySchool[benIdx] = this.props.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("Secondary")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
              }
            );
          }
          if (subtype === "ITE") {
            curLevelBySchool[benIdx] = this.props.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("NITEC")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
              }
            );
          }
          if (subtype === "Polytechnic") {
            curLevelBySchool[benIdx] = this.props.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("Polytechnic")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
              }
            );
          }
          if (subtype === "Junior College") {
            curLevelBySchool[benIdx] = this.props.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("JC")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
              }
            );
          }
          if (subtype === "Pri/Sec School") {
            curLevelBySchool[benIdx] = this.props.data.currLevelList.filter(
              (clItem) => {
                if (
                  clItem.value.includes("Primary") ||
                  clItem.value.includes("Secondary")
                ) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
              }
            );
          }
          if (subtype === "Sec/JC School") {
            curLevelBySchool[benIdx] = this.props.data.currLevelList.filter(
              (clItem) => {
                if (
                  clItem.value.includes("Secondary") ||
                  clItem.value.includes("JC")
                ) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
              }
            );
          }
          if (subtype === "SPED") {
            curLevelBySchool[benIdx] = this.props.data.currLevelList.filter(
              (clItem) => {
                if (clItem.value.includes("SPED")) {
                  return { value: clItem.value, label: clItem.label };
                }
                // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
              }
            );
          }
        }
      });
      document
        .getElementById(`Ben${benIdx}[Stream__c]`)
        .setAttribute("disabled", "true");
      document
        .getElementById(`Ben${benIdx}[Current_Level__c]`)
        .setAttribute("value", "");
      BenList[benIdx].data.Stream__c = "";
      BenList[benIdx].data.Current_Level__c = "";
      if (
        event.target.value.indexOf("Polytechnic") !== -1 ||
        event.target.value.indexOf("ITE") !== -1
      ) {
        document
          .getElementById(`Ben${benIdx}[Course_c]`)
          .setAttribute("disabled", "true");
        document
          .getElementById(`Ben${benIdx}[Course_c]`)
          .setAttribute("value", "");
      }
    }

    if (event.target.name.indexOf("Current_Level") !== -1) {
      if (event.target.value.indexOf("Secondary") === -1) {
        BenList[benIdx].data.Stream__c = "";
        document
          .getElementById(`Ben${benIdx}[Stream__c]`)
          .setAttribute("disabled", "true");
      } else {
        document
          .getElementById(`Ben${benIdx}[Stream__c]`)
          .removeAttribute("disabled");
      }
      // if (event.target.value.indexOf('Polytechnic') !== -1 || event.target.value.indexOf('ITE') !== -1) {
      //     console.log('enter 3');
      //     document.getElementById(`Ben${benIdx}[Course_c]`).setAttribute('disabled', 'true');
      //     document.getElementById(`Ben${benIdx}[Course_c]`).setAttribute('value', '');
      // }
    }

    if (event.target.name.indexOf("Relationship_to_Applicant__c") !== -1) {
      if (value !== "Others") {
        // Empties Relationship_to_Applicant_Other__c
        BenList[benIdx].data.Relationship_to_Applicant_Other__c = "";
      }
    }

    // console.log(BenList[benIdx]);
    BenList[benIdx].data[event.target.name] = value;
    this.setState({
      Ben: BenList,
      subTypes,
      curLevelBySchool,
    });
    this.props.changeState("Ben", BenList);
  }

  // this.props.data.Ben[index].data.Current_School__c,index,length
  currentLevalUpdate(value, indexFunc, length) {
    let currentLevelData = [[]];
    let index = indexFunc;

    this.props.data.schoolList.map((item) => {
      if (item.value === value) {
        const subtype = item.type;

        if (subtype === "Primary School") {
          currentLevelData = this.props.data.currLevelList.filter((clItem) => {
            if (clItem.value.includes("Primary")) {
              return { value: clItem.value, label: clItem.label };
            }
            // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
          });
          console.log("currentLevelData");
          console.log(currentLevelData);
        }
        if (subtype === "Secondary School") {
          currentLevelData = this.props.data.currLevelList.filter((clItem) => {
            if (clItem.value.includes("Secondary")) {
              return { value: clItem.value, label: clItem.label };
            }
            // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
          });
        }
        if (subtype === "ITE") {
          currentLevelData = this.props.data.currLevelList.filter((clItem) => {
            if (
              clItem.value.includes("NITEC") ||
              clItem.value.includes("Technical Diploma")
            ) {
              return { value: clItem.value, label: clItem.label };
            }
            // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
          });
        }
        if (subtype === "Polytechnic") {
          currentLevelData = this.props.data.currLevelList.filter((clItem) => {
            if (clItem.value.includes("Polytechnic")) {
              return { value: clItem.value, label: clItem.label };
            }
            // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
          });
        }
        if (subtype === "Junior College") {
          currentLevelData = this.props.data.currLevelList.filter((clItem) => {
            if (clItem.value.includes("JC")) {
              return { value: clItem.value, label: clItem.label };
            }
            // document.getElementById(`Ben${benIdx}[Stream__c]`).setAttribute('disabled', 'true');
          });
        }
        if (subtype === "Pri/Sec School") {
          currentLevelData = this.props.data.currLevelList.filter((clItem) => {
            if (
              clItem.value.includes("Primary") ||
              clItem.value.includes("Secondary")
            ) {
              return { value: clItem.value, label: clItem.label };
            }
            // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
          });
        }
        if (subtype === "Sec/JC School") {
          currentLevelData = this.props.data.currLevelList.filter((clItem) => {
            if (
              clItem.value.includes("Secondary") ||
              clItem.value.includes("JC")
            ) {
              return { value: clItem.value, label: clItem.label };
            }
            // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
          });
        }
        if (subtype === "SPED") {
          currentLevelData = this.props.data.currLevelList.filter((clItem) => {
            if (clItem.value.includes("SPED")) {
              return { value: clItem.value, label: clItem.label };
            }
            // document.getElementById(`Ben${benIdx}[Stream__c]`).removeAttribute('disabled');
          });
        }
      }
    });
    const data = this.state.curLevelBySchool;
    data[index] = currentLevelData;
    this.setState({
      curLevelBySchool: data,
    });
    index++;

    if (index < length) {
      this.currentLevalUpdate(
        this.props.data.Ben[index].data.Current_School__c,
        index,
        length
      );
    }
  }

  async uploadBen(event) {
    if (event.target.files[0] !== undefined) {
      const file = event.target.files[0];
      const benId = Number(event.target.id.match(/\d+/)[0]);
      const { Ben } = this.props.data;
      const ben = Ben[benId];
      const attachment = {
        Name: `Nric_Fin_${file.name.replace(" ", "_")}`,
        // Body: file,
        parentId: "", // the id of the opportunity
        ContentType: file.type,
      };
      const encodedFile = await getBase64(file);
      [, attachment.Body] = encodedFile.split(",");
      ben.attachment = attachment;

      // NOTE: state.Ben in <Registration> and props.data.Ben in <Tab3> have already been updated by this point

      document.getElementById(`fileName${benId}`).innerHTML = file.name;
    }
  }

  removeFile(event) {
    const benId = Number(event.target.id.match(/\d+/)[0]);
    const ben = this.props.data.Ben[benId];
    ben.attachment = {};
    document.getElementById(`fileName${benId}`).innerHTML = "";
    document.getElementById(`Ben${benId}[file]`).val(null);
  }

  render() {
    const that = this;
    // const { dob } = this.state;
    // const handleDOBChange = this.handleDOBChange.bind(this);
    // const cs_handleChange = this.csChanged.bind(this);
    // const at_handleChange = this.atChanged.bind(this);
    // const school_list = this.state.schoolList;
    const { state, props } = this;

    // let applyingTo = null;
    //
    // // If this is an application renewal, applyingTo will always refer to current partner account
    // const params = new URLSearchParams(window.location.search);
    // if (params.get('renewFrom')) {
    //     applyingTo = props.user.loggedInUser.Account.Id;
    // }

    // applyingTo will always refer to current partner account
    const applyingTo = props.user.loggedInUser.Account.Id;

    return (
      <div className="col-md-12 print" id="tab3">
        <br />
        <h4 className="info-text"> Beneficiaries List</h4>
        <br />
        {/* Array.apply(0, Array(state.bencount)).map((x, i) => ( */}
        {/* props.data.Ben.length */}
        {/* Array.apply(null, { length: state.bencount }).map(Number.call, Number).map(i => { */}
        {props.data.Ben.map((bene, i) => {
          if (applyingTo) {
            props.data.Ben[i].data.Applying_to__c = applyingTo;
          }

          return (
            <div className="full" key={i.toString()}>
              <div className="row">
                <div className="col-sm-6">
                  <p>Beneficiary - {i + 1} </p>
                </div>
                <div className="col-sm-6 right">
                  {/* i > 0 &&
                                        <button
                                            className="small"
                                            id={`Ben[${i}][minbutton]`}
                                            onClick={this.minCount}
                                        >
                                            <i id={`Ben[${i}][mincount]`} className="fa fa-minus" />
                                        </button> */}
                  <button
                    className="small"
                    id={`Ben[${i}][minbutton]`}
                    onClick={this.minCount}
                  >
                    <i id={`Ben[${i}][mincount]`} className="fa fa-minus" />
                  </button>
                </div>
              </div>
              {/* Row 1 */}
              <div className="row">
                {/* Full Name */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      Full Name in NRIC{" "}
                      <small style={{ color: "red" }}>(required)</small>
                    </label>
                    <input
                      onChange={this.updateBen}
                      name="Full_Name__c"
                      id={`Ben${i}][Full_Name_del__c]`}
                      type="text"
                      className="form-control"
                      value={
                        bene.data !== undefined
                          ? bene.data.Full_Name__c !== undefined
                            ? bene.data.Full_Name__c
                            : ""
                          : ""
                      }
                      required
                    />
                  </div>
                </div>
                {/* ID TYPE */}
                <div className="col-sm-3">
                  <label>
                    ID Type <small className="red">(required)</small>
                  </label>
                  <input
                    /* id="ID_Type__c" */
                    name="ID_Type__c"
                    id={`Ben${i}[ID_Type__c]`}
                    className="form-control"
                    aria-invalid="false"
                    value={
                      bene.data !== undefined
                        ? bene.data.ID_Type__c !== undefined
                          ? bene.data.ID_Type__c
                          : "NRIC"
                        : "NRIC"
                    }
                    readOnly
                  />
                </div>
                {/* NRIC */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      NRIC/Birth Cert Number{" "}
                      <small style={{ color: "red" }}>(required)</small>{" "}
                    </label>
                    <input
                      onChange={this.updateBen}
                      name="ID_Number__c"
                      id={`Ben${i}[ID_Number__c]`}
                      type="text"
                      className="form-control"
                      value={
                        bene.data !== undefined
                          ? bene.data.ID_Number__c !== undefined
                            ? bene.data.ID_Number__c
                            : ""
                          : ""
                      }
                    />
                    <span id={`ben_nric_error${i}`} style={{ color: "red" }} />
                  </div>
                </div>
                {/* Date of Birth */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      Date of Birth{" "}
                      <small style={{ color: "red" }}>(required)</small>
                    </label>
                    <DatePicker
                      name="Date_of_Birth__c"
                      selected={
                        bene !== undefined
                          ? bene.data.Date_of_Birth__c !== ""
                            ? moment(bene.data.Date_of_Birth__c)
                            : null
                          : null
                      }
                      id={`Ben${i}[Date_of_Birth__c]`}
                      dateFormat="DD/MM/YYYY"
                      onChange={(date) => {
                        if (moment() < date) {
                          swal({
                            type: "warning",
                            title: "Invalid Date of Birth!",
                            text: "date of birth cannot be future date!",
                          });
                        } else {
                          const newDate = date.format("YYYY-MM-DD").toString();
                          bene.data.Date_of_Birth__c = newDate;
                          const { Ben } = this.props.data;
                          Ben[i] = bene;
                          this.props.changeState("Ben", Ben);
                          // that.forceUpdate();
                        }
                      }}
                      className="form-control fullw"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </div>
                </div>
              </div>
              {/* row 2 */}
              <div className="row">
                {/* Gender */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      Gender <small style={{ color: "red" }}>(required)</small>
                    </label>
                    <select
                      name="Gender__c"
                      ref="Ben[{i}][Gender__c]"
                      id={`Ben${i}[Gender__c]`}
                      onChange={this.updateBen}
                      className="form-control select"
                      value={
                        bene.data.Gender__c !== undefined
                          ? bene.data.Gender__c
                          : ""
                      }
                      required
                    >
                      <option value="" />
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                </div>
                {/* Race */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      Race <small style={{ color: "red" }}>(required)</small>
                    </label>
                    <select
                      onChange={this.updateBen}
                      name="Race__c"
                      id={`Ben${i}[Race__c]`}
                      className="form-control select"
                      value={
                        bene.data.Race__c !== undefined ? bene.data.Race__c : ""
                      }
                    >
                      <option value="" />
                      {props.data.raceList !== undefined &&
                        props.data.raceList.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                {/* Other Race */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Other Race</label>
                    <input
                      onChange={this.updateBen}
                      name="Other_Race__c"
                      id={`Ben${i}[Other_Race__c]`}
                      type="text"
                      className="form-control"
                      value={
                        bene.data.Other_Race__c !== undefined &&
                        bene.data.Race__c === "Others"
                          ? bene.data.Other_Race__c
                          : ""
                      }
                      disabled={bene.data.Race__c !== "Others"}
                    />
                  </div>
                </div>
                {/* Nationality */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      Nationality{" "}
                      <small style={{ color: "red" }}>(required)</small>
                    </label>
                    <select
                      name="Nationality__c"
                      id={`Ben${i}[Nationality__c]`}
                      onChange={this.updateBen}
                      className="form-control select"
                      value={
                        bene.data.Nationality__c !== undefined
                          ? bene.data.Nationality__c
                          : ""
                      }
                    >
                      <option value="" />
                      {props.data.nationList !== undefined &&
                        props.data.nationList.map((nationItem) => {
                          if (nationItem.value !== "Others") {
                            return (
                              <option
                                key={shortid.generate()}
                                value={nationItem.value}
                              >
                                {nationItem.label}
                              </option>
                            );
                          }
                        })}
                    </select>
                  </div>
                </div>
              </div>
              {/* Row 3 */}
              <div className="row">
                {/* Other Nationality */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Other Nationality</label>
                    <input
                      onChange={this.updateBen}
                      name="Other_Nationality__c"
                      id={`Ben${i}[Other_Nationality__c]`}
                      type="text"
                      className="form-control"
                      value={
                        bene.data.Other_Nationality__c &&
                        bene.data.Nationality__c === "Singaporean PR"
                          ? bene.data.Other_Nationality__c
                          : ""
                      }
                      disabled={bene.data.Nationality__c !== "Singaporean PR"}
                    />
                  </div>
                </div>
                {/* Current School */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      School <small style={{ color: "red" }}>(required)</small>
                    </label>
                    <select
                      name="Current_School__c"
                      // ref="Ben[{i}][Current_School__c]"
                      ref={this.setCurrentSchoolRef}
                      id={`Ben${i}[Current_School__c]`}
                      onChange={this.updateBen}
                      className="form-control select"
                      value={
                        bene.data.Current_School__c !== undefined
                          ? bene.data.Current_School__c
                          : ""
                      }
                      required
                    >
                      <option value="">
                        ---Please Select Current School---
                      </option>
                      {props.data.schoolList.map((school_opt) => (
                        <option
                          key={school_opt.value}
                          value={school_opt.value}
                          subtype={school_opt.type}
                        >
                          {school_opt.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* Current Level */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      Current level{" "}
                      <small style={{ color: "red" }}>(required)</small>
                    </label>
                    <select
                      onChange={this.updateBen}
                      name="Current_Level__c"
                      id={`Ben${i}[Current_Level__c]`}
                      className="form-control select"
                      value={
                        bene.data.Current_Level__c !== undefined
                          ? bene.data.Current_Level__c
                          : ""
                      }
                    >
                      <option value="" />
                      {state.curLevelBySchool[i] !== undefined
                        ? state.curLevelBySchool[i].map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
                {/* Stream */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Stream</label>
                    <select
                      onChange={this.updateBen}
                      name="Stream__c"
                      id={`Ben${i}[Stream__c]`}
                      className="form-control select"
                      value={
                        bene.data.Stream__c !== undefined
                          ? bene.data.Stream__c
                          : ""
                      }
                      disabled={state.subTypes[i] !== "Secondary School"}
                    >
                      <option value="" />
                      {props.data.streamList !== undefined &&
                        props.data.streamList.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              {/* Row 4 */}
              <div className="row">
                {/* Applying To */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      Applying to{" "}
                      <small style={{ color: "red" }}>(required)</small>
                    </label>
                    <select
                      name="Applying_to__c"
                      className="form-control select"
                      // ref="Ben[{i}][Applying_to__c]"
                      id={`Ben${i}[Applying_to__c]`}
                      // onChange={this.updateBen}
                      value={bene.data.Applying_to__c}
                      required
                      disabled
                    >
                      <option value="">---Please Select Applying to---</option>
                      {this.state.renewalApplication
                        ? state.applyingToList.length > 0
                          ? state.applyingToList[i].map((school_opt) => (
                              <option
                                key={`at${school_opt.value}`}
                                value={school_opt.value}
                              >
                                {school_opt.label}
                              </option>
                            ))
                          : null
                        : state.applyingToList[i].map((school_opt) => (
                            <option
                              key={`at${school_opt.value}`}
                              value={school_opt.value}
                            >
                              {school_opt.label}
                            </option>
                          ))}
                    </select>
                  </div>
                </div>
                {/* Email */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      onChange={this.updateBen}
                      name="Email_Address__c"
                      id={`Ben${i}[Email_Address__c]`}
                      type="text"
                      className="form-control"
                      value={
                        bene.data.Email_Address__c !== undefined
                          ? bene.data.Email_Address__c
                          : ""
                      }
                    />
                    <span id={`ben_email_error${i}`} style={{ color: "red" }} />
                  </div>
                </div>
                {/* Relationship to Applicant */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      Relationship to Applicant{" "}
                      <small className="red">(required)</small>
                    </label>
                    <br />
                    <select
                      name="Relationship_to_Applicant__c"
                      id={`Ben${i}[Relationship_to_Applicant__c]`}
                      className="form-control relation1 select"
                      onChange={this.updateBen}
                      value={
                        bene.data.Relationship_to_Applicant__c
                          ? bene.data.Relationship_to_Applicant__c
                          : ""
                      }
                    >
                      <option value="" />
                      {props.data.relationListFiltered.map((rel) => (
                        <option key={rel.value} value={rel.value}>
                          {rel.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Other Relationship</label>
                    <br />
                    <input
                      onChange={this.updateBen}
                      name="Relationship_to_Applicant_Other__c"
                      id={`Ben${i}[Relationship_to_Applicant_Other__c]`}
                      type="text"
                      className="form-control"
                      disabled={
                        bene.data.Relationship_to_Applicant__c !== "Others"
                      }
                      value={bene.data.Relationship_to_Applicant_Other__c}
                      maxLength="255"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Recommended Months of Payout</label>
                    <br />
                    <input
                      onChange={this.updateBen}
                      name="No_of_Receipts_Approved__c"
                      id={`Ben${i}[No_of_Receipts_Approved__c]`}
                      type="number"
                      min="0"
                      className="form-control"
                      value={bene.data.No_of_Receipts_Approved__c}
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Recommended Start Date of Payout</label>
                    <br />
                    <DatePicker
                      name="Payout_Start__c"
                      selected={
                        bene !== undefined
                          ? bene.data.Payout_Start__c !== ""
                            ? moment(bene.data.Payout_Start__c)
                            : null
                          : null
                      }
                      id={`Ben${i}[Payout_Start__c]`}
                      dateFormat="DD/MM/YYYY"
                      onChange={(date) => {
                        const newDate = date.format("YYYY-MM-DD").toString();
                        bene.data.Payout_Start__c = newDate;
                        const { Ben } = this.props.data;
                        Ben[i] = bene;
                        this.props.changeState("Ben", Ben);
                        // that.forceUpdate();
                      }}
                      className="form-control fullw"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      minDate={moment(new Date())}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                {/* Upload NRIC */}
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>NRIC/Birth Cert File</label>
                    <br />
                    <label className="fileContainer">
                      Choose File
                      <input
                        onChange={that.uploadBen}
                        onClick={(e) => {
                          e.target.value = null;
                        }}
                        type="file"
                        className="form-control-file"
                        id={`Ben${i}[file]`}
                        aria-describedby="fileHelp1"
                        // multiple
                        accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/pjpeg,image/png,application/pdf"
                      />
                    </label>
                    &nbsp;
                    <span
                      id={`fileName${i}`}
                      style={{ fontSize: "10pt", fontWeight: "bold" }}
                    >
                      {bene.attachment.Name}
                    </span>
                    &nbsp;
                    <i
                      id={`Ben${i}[removefile]`}
                      className="fa fa-times-circle"
                      onClick={that.removeFile}
                      onKeyDown={that.removeFile}
                      role="button"
                      tabIndex="-1"
                    />
                    <label>
                      <small id="fileHelp1" className="form-text text-muted">
                        Upload NRIC/Birth Cert File, format : jpg, png, pdf only
                      </small>
                    </label>
                  </div>
                </div>
              </div>
              <hr className="dashed" />
            </div>
          );
        })}
        <br />
        <center>
          <button onClick={this.addCount} className="btn btn-primary">
            Add more beneficiary
          </button>
        </center>
        <br />
      </div>
    );
  }
}

Tab3.propTypes = {
  // title: PropTypes.string,
  salesforce: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  changeState: PropTypes.func.isRequired,
};

Tab3.defaultProps = {
  // title: 'Tab3 ',
};

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = (state) => ({
  user: state.user,
  salesforce: state.salesforce,
});

export default connect(mapStateToProps, mapDispatchToProps)(Tab3);



//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/tab3.js
// module id = 1046
// module chunks = 0